import RelatedSchematicsWidget from "@/abilities/schematic-viewer/widgets/related-schematics/related-schematics.widget.vue";
import { AccessFeature } from "@/shared/access-control/access-control";
import { createRouteFromRouteElements } from "@/shared/environment/ability-route-helper";
import type { Ability, Route, RouteElementWithParam, Widget } from "@/shared/environment/ability.types";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases";

export const SCHEMATIC_VIEWER_ALIAS = "schematic-viewer";
const parentAliases: CommonRouteAliases[] = [CommonRouteAliases.asset, CommonRouteAliases.product];

export class SchematicViewerAbility implements Ability {
    alias = SCHEMATIC_VIEWER_ALIAS;
    access = {
        accessFeature: AccessFeature.schematic_viewer,
    };

    getRoutes = (): Array<Route> => [
        {
            alias: CommonRouteAliases.schematicViewer,
            params: ["schemaId", "schemaPath"],
            getComponent: () => import("@/abilities/schematic-viewer/pages/schematic-viewer-screen.vue"),
            parentAliases,
            getBreadCrumbs: (
                parentElements: Array<RouteElementWithParam>,
                currentElement: RouteElementWithParam,
                translateMethod: (text: string) => string
            ) => {
                return [
                    {
                        content: {
                            simpleText: translateMethod("schematic-viewer.Title"),
                        },
                        getRouterTo: () => createRouteFromRouteElements(parentElements, currentElement),
                    },
                ];
            },
        },
        {
            alias: CommonRouteAliases.schematics,
            params: [],
            isRoot: true,
            parentAliases,
            getComponent: () => import("@/abilities/schematic-viewer/pages/schematics-overview-page.vue"),
            getBreadCrumbs: (
                parentElements: Array<RouteElementWithParam>,
                currentElement: RouteElementWithParam,
                translateMethod: (text: string) => string
            ) => {
                return [
                    {
                        content: {
                            simpleText: translateMethod("schematic-viewer.Schematics"),
                        },
                        getRouterTo: () => createRouteFromRouteElements(parentElements, currentElement),
                    },
                ];
            },
        },
    ];
    getWidgets = (): Array<Widget> => [
        {
            widgetContextAlias: ["asset", "product"],
            widgetComponent: RelatedSchematicsWidget,
        },
    ];
}
